import React from 'react';
import styled from 'styled-components/macro';
import { UserOption } from './UserDropdown';

const CustomSpanStyles = styled.div`
  width: 210px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface OptionLabelProps {
  user: UserOption;
  context: 'menu' | 'value';
}

export const CustomUsersLabel: React.FC<OptionLabelProps> = ({
  context,
  user,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {context === 'value' ? (
        <>
          <CustomSpanStyles>
            {!!user.username ? user.username : user.label}{' '}
          </CustomSpanStyles>
          {user.value !== 'add' && (
            <CustomSpanStyles style={{ width: 85, textAlign: 'right' }}>
              {user.value}
            </CustomSpanStyles>
          )}
        </>
      ) : (
        <>
          <CustomSpanStyles>{user.label}</CustomSpanStyles>
          {user.value !== 'add' && user.value}
        </>
      )}
    </div>
  );
};
